import { Row, Col } from 'react-bootstrap';
import Cards from '../../../components/pages/reports/Cards';
import QuizReportIcon from '../../../assets/icons/QuizReportIcon.svg'
import AssessmentReportIcon from '../../../assets/icons/AssessmentReportIcon.svg'
import AssessmentPracticalIcon from '../../../assets/icons/AssessmentPracticalIcon.svg'
import IncidentReportIcon from '../../../assets/icons/IncidentReportIcon.svg'
import IncidentMisReportIcon from '../../../assets/icons/IncidentMisReportIcon.svg'
import CyberRangeReportIcon from '../../../assets/icons/CyberRangeIcon.svg'
import CyberRangeSessionReportIcon from '../../../assets/icons/CyberRangeReportIcon.svg'
const cards = [
  { title: 'Recent Login History Report', icon: AssessmentPracticalIcon, bg: '#FFDD9D', path: 'reports/recent-login-history-report' },
  { title: 'Login History Report', icon: IncidentMisReportIcon, bg: '#FFBDB7', path: 'reports/login-history-report' },
  { title: 'First Login Policy Acceptance Report', icon: AssessmentPracticalIcon, bg: '#FFDD9D', path: 'reports/first-login-policy-acceptance-report' },
  { title: 'Bay Utilization Report', icon: CyberRangeReportIcon, bg: '#E3F0FF', path: 'reports/bay-utilization-report' },
  { title: 'Bay Sessions Report', icon: CyberRangeSessionReportIcon, bg: '#ddd', path: 'reports/bay-sessions-report' },
  { title: 'Incident Report', icon: IncidentReportIcon, bg: '#D9D2FF', path: 'reports/incident-report' },
  { title: 'Incident MIS Report', icon: IncidentMisReportIcon, bg: '#FFBDB7', path: 'reports/incident-mis-report' },
  { title: 'Quiz MCQ Report', icon: QuizReportIcon, bg: '#BBD4A8', path: 'reports/quiz-report' },
  { title: 'Assessment MCQ Report', icon: AssessmentReportIcon, bg: '#FFDD9D', path: 'reports/assessment-report' },
  { title: 'Assessment Practical Report', icon: AssessmentPracticalIcon, bg: '#FFDD9D', path: 'reports/assessment-practical-report' },
];

const ReportDashboard = () => {

  return (
  <div className="container-fluid mt-3 pt-3" style={{ overflow: "hidden" }}>
        
   <Row className="justify-content-start">
        {cards.map((card, idx) => (
          <Col key={idx} xs={6} sm={4} md={4} lg={2}>
            <Cards title={card.title} icon={card.icon} path={card.path} bg={card.bg} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ReportDashboard;
